import { t } from "ttag";

import type { Tab } from "./types";

export const TABS: Tab[] = [
  { label: t`Хооронд`, operator: "between" },
  { label: t`Сонгосон өдрөөс өмнөх`, operator: "<" },
  { label: t`Өдөр сонгох`, operator: "=" },
  { label: t`Сонгосон өдрөөс хойш`, operator: ">" },
];
